import { Flex, Text, Button } from "@chakra-ui/react";
import { Link } from "react-router-dom";

const CancelPage = () => {
  return (
    <Flex direction="column" align="center" justify="center" minH="100vh" bg="red.50" p={6}>
      <Text fontSize="3xl" color="red.700" mb={4}>
        ❌ Transazione annullata
      </Text>
      <Text fontSize="lg" color="gray.700" mb={6}>
        Nessun addebito è stato effettuato. Puoi riprovare quando vuoi dalla sezione Billing.
      </Text>
      <Button as={Link} to="/billing" colorScheme="red" size="lg">
        Torna alla pagina Billing
      </Button>
    </Flex>
  );
};

export default CancelPage;
